<form #loginForm="ngForm" (ngSubmit)="changePassword(loginForm)">
    <div class="container-fluid">
      <h2 >Change Password</h2>   
      <br/>
      <input type="password" id="oldpass" name="password" ngModel class="form-control" placeholder="Old Password" required autofocus>
      <br/>
      <input type="password" id="newpass" name="newPassword" ngModel class="form-control" placeholder="New Password" required>
      <br/>
      <input type="password" id="newpassconfirm" name="newPasswordConfirm" ngModel class="form-control" placeholder="Confirm New Password" required>
      <br />

      <div class="alert alert-danger alert-dismissible" *ngIf="invalidChange">
        <button type="button" class="btn close h-100" data-dismiss="alert" (click)=dismiss()>&times;</button>
        {{message}}
      
        <button class="btn" 
                *ngIf="passproblem"
                ngbPopover="The password must be between 6 and 20 characters long and must contain at least one numeric digit, one uppercase and one lowercase letter"
                placement="bottom">
          <i class="fas fa-question-circle"></i>
        </button>
      </div>

      <button *ngIf="!startWaitingAnimation" class="btn btn-lg btn-primary btn-block" type="submit">Change</button>
      <div *ngIf="startWaitingAnimation" class="w-100 d-flex justify-content-center">
        <div class="spinner-border text-primary"></div>
      </div>

    </div>
</form>